module.exports = __webpack_public_path__ + "static/awards-logo1-7a7ffb2c0525b165b141310676fa84af.jpg";